import { ReactTable } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InsurancePolicy } from '../../../../../../../types/AdvisoryReport';
import useInsurancePolicyRisksTable from './useInsurancePolicyRisksTable';

interface Props {
  insurancePolicy: InsurancePolicy;
  showPremium?: boolean;
}

const InsurancePolicyRisksTable: React.FC<Props> = ({
  insurancePolicy,
  showPremium,
}) => {
  const { t } = useTranslation();
  const { data, columns } = useInsurancePolicyRisksTable(
    insurancePolicy,
    showPremium,
  );
  return (
    <ReactTable
      variant="borderless"
      data={data}
      columns={columns}
      emptyText={t('ADVISORY-REPORTS_CURRENT-INSURANCE_EMPTY-COVERAGES')}
      borderBottom="none"
    />
  );
};

export default InsurancePolicyRisksTable;
